import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyFormatPipe, TranslatePipe } from '@domgen/dgx-fe-i18n';
import { RegistrationPromotionPillComponent } from '@us-registration/ui-components';

@Component({
  selector: 'us-registration-protection-details-quote-offer-wib',
  templateUrl: './protection-details-quote-offer.component.html',
  styleUrls: ['./protection-details-quote-offer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CurrencyFormatPipe,
    NgIf,
    NgTemplateOutlet,
    RegistrationPromotionPillComponent,
    TranslatePipe,
  ],
})
export class ProtectionDetailsQuoteOfferComponent {
  @Input() hasDiscountPrice = false;
  @Input() quoteBrand?: string;
  @Input() quoteOriginalPrice?: number;
  @Input() quoteDiscountedPrice?: number;
  @Input() stacked = false;
  @Input() subscription?: string;
}
